import { Box, IconContainerProps, Rating, SxProps, Theme, Typography } from '@mui/material';

import theme from '@/styles/theme';

interface ICustomIconContainer extends IconContainerProps {
  selectedValue: number;
}

interface ICustomRatingIconContainer {
  value: number;
  handleOnChange?: (value: number | null) => void;
  isDisabled?: boolean;
  containerStyle?: SxProps<Theme>;
  showRating?: boolean;
}

const CustomRatingIconContainer = (props: ICustomIconContainer) => {
  const { value, selectedValue, ...rest } = props;

  const showSelected = selectedValue && selectedValue >= value;
  return (
    <Box
      {...rest}
      sx={{
        borderRadius: '50%',
        background: showSelected ? theme.palette.primary.main : undefined,
        border: 2,
        borderColor: showSelected ? theme.palette.primary.main : theme.palette.colors.lightGrey,
        height: '20px',
        width: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ml: 1,
      }}
    >
      {showSelected ? (
        <Typography fontSize={'0.625rem'} fontWeight={500} color={theme.palette.colors.white}>
          {value}
        </Typography>
      ) : null}
    </Box>
  );
};

const CustomRating = (props: ICustomRatingIconContainer) => {
  const { value, handleOnChange, isDisabled, containerStyle, showRating } = props;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        ...containerStyle,
      }}
    >
      {showRating || value > 0 ? (
        <Rating
          name="simple-controlled"
          value={value}
          onChange={(_event, newValue) => {
            if (handleOnChange) {
              handleOnChange(newValue ? newValue : 0);
            }
          }}
          sx={{
            margin: 0,
          }}
          disabled={isDisabled}
          IconContainerComponent={(props) => (
            <CustomRatingIconContainer {...props} selectedValue={value} />
          )}
        />
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', ml: 1 }}>
          <Typography variant="body2" color={theme.palette.colors.lightGrey}>
            {'-'}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default CustomRating;
